import React from 'react';

const GROUPS = [
  { platform: 'facebook', label: 'Facebook pages' },
  { platform: 'instagram', label: 'Instagram accounts' },
];

// Checkbox list of every Facebook page and Instagram account a post can go to, grouped by network.
// `selected` and `onChange` work in account keys ("facebook:<id>" / "instagram:<id>").
const SocialAccountPicker = ({ accounts = [], selected = [], onChange, disabled = false, loading = false, error = null, name = 'social-accounts' }) => {
  if (loading && accounts.length === 0) return <small className="text-muted">Loading accounts…</small>;
  if (error) return <small className="text-danger">{error}</small>;
  if (accounts.length === 0) {
    return (
      <small className="text-muted">
        No Facebook pages or Instagram accounts are connected yet. Connect them in Settings → Accounts &amp; Pages.
      </small>
    );
  }

  const chosen = new Set(selected);
  const toggle = (key) => {
    const next = new Set(chosen);
    if (next.has(key)) next.delete(key); else next.add(key);
    // Keep the list's own order so saves are stable.
    onChange?.(accounts.map((a) => a.key).filter((k) => next.has(k)));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {GROUPS.map(({ platform, label }) => {
        const rows = accounts.filter((a) => a.platform === platform);
        if (rows.length === 0) return null;
        return (
          <div key={platform}>
            <div style={{ fontSize: '12px', fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>{label}</div>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              {rows.map((account) => (
                <label
                  key={account.key}
                  style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: disabled ? 'not-allowed' : 'pointer', pointerEvents: 'auto' }}
                >
                  <input
                    type="checkbox"
                    name={name}
                    value={account.key}
                    checked={chosen.has(account.key)}
                    onChange={() => toggle(account.key)}
                    disabled={disabled}
                    style={{ pointerEvents: 'auto' }}
                  />
                  {account.name}
                </label>
              ))}
            </div>
          </div>
        );
      })}
      {selected.length === 0 && <small className="text-danger">Pick at least one account.</small>}
    </div>
  );
};

export default SocialAccountPicker;
